import React from "react";
import PropTypes from "prop-types";

export function LayoutWrapper({ children, className = "" }) {
  return (
    <div
      className={`relative size-full flex flex-col justify-around items-center min-h-[450px] py-10 px-4 sm:px-16 bg-white ${className}`}
    >
      {children}
    </div>
  );
}

LayoutWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};
